export default "__VITE_PUBLIC_ASSET__01c0020b__"